import React from 'react'
import { IconButton } from '@mui/material'
import { FlightDeck } from 'src/components/FlightDeck/FlightDeck'
import styled from 'styled-components'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import loadComponent from 'src/utils/loadMFE'
import { useAnyPermission } from '@tomfxs/permissions-client'

interface SidebarHeaderProps {
    isSidebarOpen: boolean
    toggleSidebar: () => void
}

const Container = styled.div`
    display: flex;
    gap: 4px;
    padding: 20px 20px;
`

const UserInfoContainer = styled.div<{ $isSidebarOpen: boolean }>`
    width: 85%;
    display: ${({ $isSidebarOpen }) => ($isSidebarOpen ? '' : 'none')};
`
const FlightDeckContainer = styled.div`
    width: 15%;
`
const StyledDiv = styled.div`
    height: 30px;
    padding: 4px;
`

const StyledIconButton = styled(IconButton)`
    position: absolute;
    right: 0;
`

const SidebarUserInfo = React.lazy(() => loadComponent('orga', 'SidebarUserInfo'))

export default function UserInfo({ isSidebarOpen, toggleSidebar }: SidebarHeaderProps) {
    const hasFlightDeckPermissions = useAnyPermission(['orga.company.view', 'traiwiss.academy.view'], {})

    return (
        <>
            <StyledDiv>
                <StyledIconButton color="inherit" aria-label="open drawer" onClick={toggleSidebar} edge="start">
                    {isSidebarOpen ? <KeyboardArrowLeftIcon /> : <KeyboardArrowRightIcon />}
                </StyledIconButton>
            </StyledDiv>
            <Container>
                <UserInfoContainer $isSidebarOpen={isSidebarOpen}>
                    <SidebarUserInfo />
                </UserInfoContainer>
                <FlightDeckContainer>{hasFlightDeckPermissions && <FlightDeck />}</FlightDeckContainer>
            </Container>
        </>
    )
}
